import { render, staticRenderFns } from "./ReceivableTransactions.vue?vue&type=template&id=15943f10&"
import script from "./ReceivableTransactions.vue?vue&type=script&lang=js&"
export * from "./ReceivableTransactions.vue?vue&type=script&lang=js&"
import style0 from "./ReceivableTransactions.vue?vue&type=style&index=0&id=15943f10&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports